<template>
    <div>
        <h6 v-if="displayTitle">{{store.title}}</h6>
        <b-row>
            <b-col>
                <b>Adresse</b><br/>
                {{store.address1}}<br/>
                <span v-if="store.address2">{{store.address2}}<br/></span>
                {{store.zip + ' ' + store.city}}
            </b-col>
            <b-col>
                <div v-if="store.phone || store.fax || store.email">
                    <b>Contacts agence</b><br/>
                    <div v-if="store.phones">
                        <Icon name="phone" />
                        <b-link :href="`tel:${store.phone}`">{{ formatPhone(store.phone) }}</b-link><br/>
                    </div>
                    <div v-if="store.phone">
                        <Icon name="phone" title="tél" />
                        <span>{{ formatPhone(store.phone) }}</span><br/>
                    </div>
                    <div v-if="store.fax">
                        <Icon name="fax" title="fax" />
                        <span>{{ formatPhone(store.fax) }}</span><br/>
                    </div>
                    <div v-if="store.email">
                        <Icon name="envelope" title="email" />
                        <b-link :href="`mailto:${store.email}`">{{store.email}}</b-link><br/>
                    </div>
                </div>
                <div v-for="contact in contacts" :key="contact.id" class="pt-3">
                    <b>{{contact.title}}</b><br/>
                    <span v-for="phone in contact.phones" :key="phone">
                        <Icon name="phone" />
                        <b-link :href="`tel:${phone}`">{{ formatPhone(phone) }}</b-link>
                        <br/>
                    </span>
                    <span>
                        <Icon name="envelope" />
                        <b-link :href="`mailto:${contact.email}`">{{contact.email}}</b-link>
                    </span>
                </div>
            </b-col>
        </b-row>
        <p v-if="store.services.length > 0" class="mt-3 mb-0">
            <b>Services</b>
        </p>
        <ul v-if="store.services.length > 0">
            <li v-for="service in store.services">
                {{ service }}
            </li>
        </ul>
        <div>
            <b-table hover striped :items="hours" class="mt-3" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StoreInfos',

        store : {
            stores : 'stores',
        },

        props : {
            storeId : {
                type : String,
                required : false,
            },
            displayTitle : {
                type : Boolean,
                required : false,
                default : false,
            },
        },

        computed : {
            hours() {
                return this.store && this.store.readableHours.map(day => {
                    return JSON.parse(day);
                })
            },
            store() {
                return this.stores.filter(store => store.id === this.storeId).pop()
            },
            contacts() {
                return this.mapEdges(this.store.contacts)
            }
        },
    }
</script>
